import { useLocation } from "react-router";
import SC from "./style";
import { Breadcrumbs, Loader, Tabs } from "InnoUI/components";
import { ImagePreview } from "components";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import theme from "theme";
import OccupantDetails from "./OccupantDetails";
import OutstandingIssue from "./OutstandingIssue";
import PrimaryContacts from "./PrimaryContacts";
import ActiveJournals from "./ActiveJournals";
import { projectType } from "utils/lookUpTable";
import { useSearchParams } from "react-router-dom";
import { apiGet } from "api/callApi";
import { selectOccupant } from "@store/occupant/actions";
import { useDispatch } from "react-redux";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import Journal from "views/ProjectHome/Journal";
import OccupantHomePageShimmer from "components/OccupantHomePageShimmer";
import PageNotFound from "components/PageNotFound";
import { isEmpty } from "utils/helper";

const OccupantHomePage = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const [selectedTab, setSelectedTab] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  // const { occupantData, selectedTabName } = location.state || {};
  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );
  const [searchParams] = useSearchParams();
  const occupantId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const [occupantData, setOccupantData] = useState([]);
  const [error, setError] = useState(null);
  const isOccupantRoute = type === String(projectType.occupant);
  const hasValidOccupantId = !isEmpty(occupantId);

  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || []
  );
  const isCurrentOccupant =
    occupantData?.id && String(occupantData.id) === String(occupantId);

  const breadcrumbItems = [
    {
      label: `${currentProject?.propertyName}`,
      href: `/project-home`,
    },
    {
      label: "Levels",
      href: `/project-home/levels?type=${projectType?.property}`,
    },
    {
      label: `${occupantData?.levelName || ""}`,
      href: `/project-home/levels?type=${projectType?.property}&levelId=${occupantData?.levelId}`,
    },
    {
      // label: `${occupantData?.occupantName || ""}`,
      label: `${currentOccupant.occupantName} - ${currentOccupant.occupantNo}`,
    },
  ];

  const getOccupantDetails = async () => {
    if (!isOccupantRoute || !hasValidOccupantId) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    setOccupantData(null);
    try {
      const response = await apiGet(
        `/v1/getoccupantdetail/${occupantId}`,
        false
      );
      const nextOccupant = response?.data?.[0];

      if (!nextOccupant?.id) {
        setError("Occupant not found.");
        return;
      }

      setOccupantData(nextOccupant);
      dispatch(selectOccupant(nextOccupant));
    } catch (error) {
      console.log("Error", error);
      setError("Failed to load occupant details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getOccupantDetails();
  }, [occupantId, type]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const tabData = [{ value: 0, label: "General Information" }];

  if (!isOccupantRoute || !hasValidOccupantId || error) {
    return (
      <PageNotFound
        heading="Occupant not found"
        message="The occupant link is invalid or this occupant is not available for your account."
      />
    );
  }

  if (isLoading || (!error && !isCurrentOccupant)) {
    return <OccupantHomePageShimmer />;
  }

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={location.pathname}
      />
      <SC.BodyContainer>
        <SC.FilterContainer>
          <OccupantFilterDropdown />
        </SC.FilterContainer>
        <SC.Container>
          <SC.ResponsiveWrapper className={isLoading ? "loading" : ""}>
            {error && (
              <div
                style={{
                  background: "rgba(239, 68, 68, 0.1)",
                  border: "1px solid rgba(239, 68, 68, 0.2)",
                  borderRadius: "0.75rem",
                  padding: "1rem",
                  marginBottom: "1.5rem",
                  color: "#dc2626",
                  textAlign: "center",
                }}
              >
                {error}
              </div>
            )}

            <SC.CardsContainer>
              <SC.DetailsCard>
                <SC.ProjectDiv>
                  {occupantData &&
                    occupantData.occupantName &&
                    occupantData.occupantNo && (
                      <SC.PropertyName>
                        {occupantData?.occupantName} -{" "}
                        {occupantData?.occupantNo}
                      </SC.PropertyName>
                    )}
                  <SC.DetailsContent>
                    <SC.DetailsSection>
                      <OccupantDetails occupantData={occupantData} />
                    </SC.DetailsSection>
                    <SC.ImageSection>
                      <SC.Image>
                        <ImagePreview
                          src={occupantData?.occupantGraphic}
                          height="100%"
                          width="100%"
                          style={{ objectFit: "contain" }}
                        />
                      </SC.Image>
                    </SC.ImageSection>
                  </SC.DetailsContent>
                </SC.ProjectDiv>
              </SC.DetailsCard>
            </SC.CardsContainer>

            {/* {selectedTab === 0 && (
              <SC.ContentCardsGrid>
                <OutstandingIssue occupantData={occupantData} />
                <PrimaryContacts />
                <ActiveJournals />
              </SC.ContentCardsGrid>
            )} */}
            {selectedTab === 0 && (
              <>
                <OutstandingIssue occupantData={occupantData} />
                <PrimaryContacts />
                <ActiveJournals />
                {/* <Journal/> */}
              </>
            )}
          </SC.ResponsiveWrapper>
        </SC.Container>
      </SC.BodyContainer>
    </>
  );
};

export default OccupantHomePage;
